import * as Yup from 'yup';

const bookDemoFormSchema = () =>
  Yup.object().shape({
    first_name: Yup.string().trim().required('First name is required.'),
    last_name: Yup.string().trim().required('Last name is required.'),
    // name: Yup.string().trim().required('Name is required.'),
    dealership_name: Yup.string().required('Dealership name is required.'),
    location: Yup.string().required('State is required.'),
    position: Yup.string().required('Position is required.'),
    // no_of_sales_people: Yup.number()
    //   .positive('Number of sales people must be a positive number.')
    //   .required('Number of sales people is required.'),
    // member_of_dealer_group: Yup.number()
    //   .min(0, 'Member of dealer group is required.')
    //   .required('Member of dealer group is required.'),
    // contact_time: Yup.string().required('Contact time is required.'),
    // office_number: Yup.string()
    //   .trim()
    //   .matches(/^\+?[0-9\s]+$/, 'Office number must contain only digits.')
    //   .min(8, 'Office number is too short.')
    //   .max(15, 'Office number is too long.')
    //   .required('Office number is required.'),
    // office_number_ext: Yup.string()
    //   .trim()
    //   .matches(/^\+?[0-9\s]+$/, 'Ext number must contain only digits.')
    //   .min(1, 'Ext number is too short.')
    //   .max(15, 'Ext number is too long.'),
    // Uncomment if extension is required:
    // .required('Ext number is required.'),
    mobile_number: Yup.string()
      .trim()
      .matches(/^\+?[0-9\s]+$/, 'Mobile number must contain only digits.')
      .min(8, 'Mobile number is too short.')
      .max(15, 'Mobile number is too long.')
      .required('Mobile number is required.'),
    office_email: Yup.string()
      .trim()
      .email(
        'Email is incorrect format. Please add the correct format of email.'
      )
      .required('Email is required.'),
  });

export default bookDemoFormSchema;
